/* eslint-disable */
import { lazy } from 'react';
import ProtectedRoute from 'routes/ProtectRoute';
import Loadable from 'ui-component/Loadable';
const BillPayments = Loadable(lazy(() => import('views/BillsAndEmi/BBPS/BillPayments')));

export const bbpsUpdatedRoutes = {
    path: '',
    children: [
        {
            path: 'billPayments',
            element: <ProtectedRoute element={<BillPayments />} />
        }
    ]
}